import React from 'react';

const CalendarWhiteIcon = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<rect
				height='15'
				rx='2'
				stroke='#2E2E6B'
				width='18'
				x='3'
				y='6'
			/>
			<path
				d='M7 3L7 6'
				stroke='#2E2E6B'
				strokeLinecap='round'
			/>
			<path
				d='M17 3L17 6'
				stroke='#2E2E6B'
				strokeLinecap='round'
			/>
			<rect
				fill='#2E2E6B'
				height='2'
				rx='0.5'
				width='4'
				x='7'
				y='12'
			/>
			<rect
				fill='#2E2E6B'
				height='2'
				rx='0.5'
				width='4'
				x='7'
				y='16'
			/>
			<rect
				fill='#2E2E6B'
				height='2'
				rx='0.5'
				width='4'
				x='13'
				y='12'
			/>
			<rect
				fill='#2E2E6B'
				height='2'
				rx='0.5'
				width='4'
				x='13'
				y='16'
			/>
		</svg>
	);
};

export default CalendarWhiteIcon;
